import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./app/App";
import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/typography.css";
import "./styles/layout.css";
import "./styles/product.css";
import "./styles/print.css";

const rootElement = document.getElementById("root");
if (rootElement === null) throw new Error("Application root is missing.");

ReactDOM.createRoot(rootElement).render(<React.StrictMode><App /></React.StrictMode>);
requestAnimationFrame(() => document.getElementById("pre-hydration-shell")?.remove());
